import { Injectable } from '@angular/core';
import { StatsigClient, StatsigOptions, StatsigUser } from '@statsig/js-client';
import { ConfigurationService } from '../configuration.service';
import { UserService } from '../user.service';
import { FeatureFlagNames } from './feature-flag.types';

@Injectable({
    providedIn: 'root',
})
export class FeatureFlagService {
    private myStatsigClient: StatsigClient;

    constructor(
        private configurationService: ConfigurationService,
        private userService: UserService,
    ) {}

    public isFeatureFlagEnabled(flag: FeatureFlagNames): boolean {
        if (this.myStatsigClient) {
            return this.myStatsigClient.checkGate(flag);
        }
        console.log('FeatureFlagService: myStatsigClient is not initialized');
        return false;
    }

    public async setupStatsigConfig() {
        if (this.myStatsigClient) {
            return;
        }

        const user: StatsigUser = { userID: this.userService.user.sub, email: this.userService.user.email };
        let env = await this.configurationService.envConfig.getValue().environment;
        env = env === 'prod' ? 'production' : env === 'stage' ? 'staging' : env === 'qa' ? 'qa' : 'development';
        const options: StatsigOptions = {
            plugins: [],
            environment: { tier: env },
        };
        const sdkKey = this.configurationService.envConfig.getValue().statsigSdkKey;

        this.myStatsigClient = new StatsigClient(sdkKey, user, options);
        await this.myStatsigClient.initializeAsync();
    }
}
